import React, { useEffect, useRef, useState } from 'react';
import './DropDown.css';
import divStyles from 'src/Utils/CssModules/div.module.css';

interface ISelectControlData {
  selectedItem: string;
  items: string[];
  onSelectionChange: (item: string) => void;
  id?: string;
  disabled?: boolean;
}

const DropDown: React.FC<ISelectControlData> = ({
  selectedItem,
  items,
  onSelectionChange,
  disabled
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className={`dropdown ${isOpen ? 'show' : ''} ${disabled ? divStyles.disabled : ''}`}>
      <button
        className={`btn dropdown-toggle ${isOpen ? 'show' : ''}`}
        type="button"
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span>{selectedItem}</span>
        <i className="bi bi-chevron-down ml-auto"></i>
      </button>
      <div className={`dropdown-menu ${isOpen ? 'show' : ''}`}>
        {items.filter(item => item !== selectedItem).map((item, index) => (
          <li
            className="dropdown-item"
            key={index}
            onClick={() => {
              onSelectionChange(item);
              setIsOpen(false);
            }}
          >
            {item}
          </li>
        ))}
      </div>
    </div>
  );
};

export default React.memo(DropDown);
